import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';

import { Toast } from "primereact/toast";
export default function SendmailPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const API_BASE = process.env.REACT_APP_API_BASE;
const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = React.useRef(null);
   // Fetch records (alldata_tbl)
  useEffect(() => {
    fetch(`${API_BASE}/alldata`)
      .then((res) => res.json())
      .then((data) => setRecords(data))
      .catch((err) => console.error("Error loading records", err));
  }, []);
  // Send mail
  const sendMail = async (id) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/email/send/${id}`, {
        method: "POST",
      });
      if (res.ok) {
        toast.current.show({
          severity: "success",
          summary: "Mail Sent",
          detail: `Email sent successfully for ID: ${id}`,
        });
      } else {
        const errMsg = await res.text();
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: errMsg,
        });
      }
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Network Error",
        detail: err.message,
      });
    }
    setLoading(false);
  };
	return (
		<main id="SendmailPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="SendMail"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="p-4">
                        <Toast ref={toast} />
                        <h2 className="mb-3">Send Email from alldata_tbl</h2>
                        {loading && (
                        <div className="flex justify-content-center my-4">
                            <ProgressSpinner />
                        </div>
                        )}
                        <DataTable value={records} paginator rows={10} responsiveLayout="scroll">
                            <Column field="id" header="ID" />
                                <Column field="Business_name" header="Business" />
                                    <Column field="First_name" header="First Name" />
                                        <Column field="Email" header="Email" />
                                            <Column
                                                header="Action"
                                                body={(rowData) => (
                                                <Button
                                                label="Send Mail"
                                                icon="pi pi-send"
                                                className="p-button-sm p-button-success"
                                                onClick={() => sendMail(rowData.id)}
                                                />
                                                )}
                                                />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
		</main>
	);
}
